export function encodeValueForHtmlAttr(data: object) {
    return window.btoa(JSON.stringify(data));
}

export function decodeValueForHtmlAttr(strAttr: string) {
    return JSON.parse(window.atob(strAttr));
}